<template>
  <div class="elvas-button">
    <p class="elvas-button-text">{{button.title}}</p>
  </div>
</template>

<script>
export default {
  name: 'elvasButton',
  props: ['button']
}
</script>
<style scoped lang="scss">
.elvas-button {
  display: table;
  padding: 16px 48px;
  background-color: #f6b92f;
  transition: all 0.25s;
  cursor: pointer;
  p {
    font-family: 'Sen', sans-serif;
    text-transform: uppercase;
    font-size: 14px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1;
    letter-spacing: 1px;
    text-align: center;
    color: #ffffff;

    @media (max-width: 800px){
      font-size: 12px;
    }
  }
  &:hover {
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.25);
    background-color: #f6b92f;
  }
  &.no-filled {
    background-color: transparent;
    border: 2px solid #f6b92f;
    padding: 14px 46px;
    p {
      color: #f6b92f;
    }
  }
}
</style>